module.exports = __webpack_public_path__ + "img/FOX_FILL_whtie.6278644f.png";